export default __webpack_public_path__ + "static/media/multichain-white.ac9541df.svg";